export enum LoginResult {
  Success,
  Failure,
  AlreadyCheckedIn,
  NotFound
}
